// @flow
import React from 'react';
import FontIcon from 'material-ui/FontIcon';

import styles from './MissingSubscription.scss';

const featureItems = [
  { icon: 'place', label: ['Légterek', 'megjelenítése'] },
  { icon: 'gesture', label: ['Eseti légtér', 'tervezése'] },
  { icon: 'description', label: ['NOTAM-ok és', 'információk'] },
  { icon: 'cloud_upload', label: ['Igénylés', 'előkészítése'] },
];

const noticeItems = [
  {
    icon: 'event_note',
    text:
      'A Légtérkereső térkép közel 10 éve segíti a pilótákat, drónüzemeltetőket és légtérigénylőket. Ez idő alatt a szolgáltatás alapfunkciói mindenki számára díjmentesen elérhetők voltak.',
  },
  {
    icon: 'storage',
    text:
      'A rendszer fejlesztésére, üzemeltetésére és karbantartására az elmúlt években több tízmillió forintot fordítottunk. A szolgáltatás működése folyamatos költségekkel jár, beleértve a szerverinfrastruktúrát, a térképi szolgáltatásokat, a fejlesztéseket, a hibajavításokat és a rendszeres frissítéseket.',
  },
  {
    icon: 'assessment',
    text:
      'A Légtérkereső térkép az elmúlt közel 10 évben jórészt más szolgáltatásaink bevételeiből került finanszírozásra. A hosszú távú fenntarthatóság és a további fejlesztések érdekében a szolgáltatás előfizetéses rendszerre áll át.',
  },
  {
    icon: 'verified_user',
    text:
      'Új előfizetési csomagok!\nA Légtérkereső térkép mostantól Free, Basic, Pro és Pro+ csomagokban érhető el. A jelenlegi előfizetések a lejárati időpontjukig változatlan feltételekkel használhatók, ezt követően az új előfizetési csomagok valamelyikének kiválasztása szükséges.',
  },
];

const actionButtons = [
  {
    href: '/w/login',
    label: 'Bejelentkezés',
    icon: 'person_outline',
    primary: false,
  },
  {
    href: '/w/register',
    label: 'Regisztráció',
    icon: 'person_add',
    primary: true,
  },
];

const footerLinks = [
  { label: 'Adatvédelem', href: 'https://legter.hu/adatkezelesi-tajekoztato/' },
  {
    label: 'Általános Szerződési Feltételek',
    href: 'https://legter.hu/altalanos-szerzodesi-feltetelek/',
  },
  { label: 'Kapcsolat', href: 'https://legter.hu/rolunk/legter-hu-kft/' },
];

const classes = (...names) => names.filter(Boolean).join(' ');

const renderIcon = (name, className) => (
  <FontIcon className={classes('material-icons', className)}>{name}</FontIcon>
);

export default function MissingSubscription() {
  return (
    <div className={styles.root}>
      <div className={styles.background} />
      <div className={styles.content}>
        <header className={styles.nav}>
          <div className={styles.brandWrap}>
            <a href="https://legter.hu" className={styles.brandLink}>
              <img
                src="/assets/legter_logo.png"
                alt="Légtér.hu"
                className={styles.logo}
              />
            </a>
          </div>
          <div className={styles.navButtons}>
            {actionButtons.map(button => (
              <a
                key={button.label}
                href={button.href}
                className={classes(
                  styles.navButton,
                  button.primary && styles.navButtonPrimary
                )}
              >
                {renderIcon(
                  button.icon,
                  classes(
                    styles.smallIcon,
                    button.primary ? styles.iconWhite : styles.iconBlue
                  )
                )}
                <span>{button.label}</span>
              </a>
            ))}
          </div>
        </header>

        <div className={styles.body}>
          <section className={styles.hero}>
            <h1 className={styles.headline}>Légtérkereső térkép</h1>
            <div className={styles.accent} />
            <p className={styles.lead}>
              Tervezd meg az eseti légteret, ellenőrizd a légtérinformációkat,
              és készítsd elő az igényléshez szükséges adatokat.
            </p>
            <div className={styles.featureRow}>
              {featureItems.map(item => (
                <div key={item.icon} className={styles.featureItem}>
                  <div className={styles.featureIconWrap}>
                    {renderIcon(
                      item.icon,
                      classes(styles.icon, styles.iconNavy)
                    )}
                  </div>
                  <div className={styles.featureLabel}>
                    <div>{item.label[0]}</div>
                    <div>{item.label[1]}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className={styles.panel}>
            <div className={styles.panelHeader}>
              <div className={styles.panelHeaderIcon}>
                {renderIcon(
                  'volume_up',
                  classes(styles.icon, styles.iconWhite)
                )}
              </div>
              <h2 className={styles.panelTitle}>
                Változások a Légtérkereső térkép szolgáltatásban
              </h2>
            </div>
            <div className={styles.noticeGrid}>
              { noticeItems.map(item => (
                <div key={item.icon} className={styles.noticeCard}>
                  <div className={styles.noticeIconWrap}>
                    {renderIcon(
                      item.icon,
                      classes(styles.icon, styles.iconNavy)
                    )}
                  </div>
                  <p className={styles.noticeText}>{item.text}</p>
                </div>
              ))}
            </div>
            <div className={styles.thanksBar}>
              {renderIcon(
                'favorite_border',
                classes(styles.thanksIcon, styles.iconBlue)
              )}
              <span>
                Köszönjük az elmúlt közel 10 év bizalmát!
              </span>
            </div>
          </section>
        </div>

        <footer className={styles.footer}>
          <div className={styles.footerMeta}>
            <div className={styles.footerItem}>
              {renderIcon(
                'help_outline',
                classes(styles.smallIcon, styles.iconNavy)
              )}
              <div>
                <div className={styles.footerItemTitle}>Kérdésed van?</div>
                <div className={styles.footerItemText}>
                  Ügyfélszolgálatunk szívesen segít.
                </div>
              </div>
            </div>
            <div className={styles.footerItem}>
              {renderIcon(
                'mail_outline',
                classes(styles.smallIcon, styles.iconNavy)
              )}
              <div>
                <div className={styles.footerItemTitle}>legter@legter.hu</div>
                <a
                  href="mailto:legter@legter.hu"
                  className={styles.footerItemText}
                >
                  Írj nekünk bizalommal!
                </a>
              </div>
            </div>
            <div className={styles.footerItem}>
              {renderIcon(
                'language',
                classes(styles.smallIcon, styles.iconNavy)
              )}
              <div>
                <div className={styles.footerItemTitle}>www.legter.hu</div>
                <a href="https://legter.hu" className={styles.footerItemText}>
                  További információkért látogass el oldalunkra!
                </a>
              </div>
            </div>
          </div>
          <div className={styles.footerLinks}>
            {footerLinks.map((link, index) => (
              <React.Fragment key={link.label}>
                {index > 0 && <span className={styles.footerDivider}>|</span>}
                <a href={link.href} className={styles.footerLink}>
                  {link.label}
                </a>
              </React.Fragment>
            ))}
          </div>
        </footer>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/Map/MissingSubscription.js